import { useState } from 'react';
import './SavedJobs.css';

export default function SavedJobs() {
  const [savedJobs, setSavedJobs] = useState([
    {
      id: 1,
      title: 'Senior Product Designer',
      company: 'TechCorp',
      location: 'San Francisco, CA',
      type: 'Full-time',
      posted: '2 days ago',
      salary: '$120,000 - $150,000',
      logo: 'https://via.placeholder.com/40',
      saved: true,
    },
    {
      id: 2,
      title: 'UX/UI Designer',
      company: 'DesignHub',
      location: 'Remote',
      type: 'Contract',
      posted: '1 week ago',
      salary: '$80 - $100/hr',
      logo: 'https://via.placeholder.com/40/0000FF/FFFFFF?text=DH',
      saved: true,
    },
    {
      id: 3,
      title: 'Lead Product Designer',
      company: 'InnovateX',
      location: 'New York, NY',
      type: 'Full-time',
      posted: '3 days ago',
      salary: '$140,000 - $180,000',
      logo: 'https://via.placeholder.com/40/FF0000/FFFFFF?text=IX',
      saved: true,
    },
  ]);

  const removeJob = (id: number) => {
    setSavedJobs(savedJobs.filter(job => job.id !== id));
  };

  return (
    <div className="saved-jobs-container">
      <div className="saved-jobs-card">
        <div className="saved-jobs-header">
          <h2 className="saved-jobs-title">Saved Jobs</h2>
          <p className="saved-jobs-subtitle">Your saved job listings</p>
        </div>
        
        <div className="job-list">
          {savedJobs.length === 0 ? (
            <div className="empty-state">
              <svg
                className="empty-state-icon"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                aria-hidden="true"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={1}
                  d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
              <h3 className="empty-state-title">No saved jobs</h3>
              <p className="empty-state-message">
                Get started by saving jobs that interest you.
              </p>
              <button
                type="button"
                className="browse-jobs-button"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                  aria-hidden="true"
                >
                  <path
                    fillRule="evenodd"
                    d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z"
                    clipRule="evenodd"
                  />
                </svg>
                Browse Jobs
              </button>
            </div>
          ) : (
            savedJobs.map((job) => (
              <div key={job.id} className="job-item">
                <div className="job-content">
                  <div className="job-details">
                    <div className="job-header">
                      <img
                        className="company-logo"
                        src={job.logo}
                        alt={`${job.company} logo`}
                      />
                      <div>
                        <h3 className="job-title">{job.title}</h3>
                        <div className="job-meta">
                          <span className="job-company">{job.company}</span>
                          <span className="job-location">{job.location}</span>
                          <span className="job-type">{job.type}</span>
                        </div>
                      </div>
                    </div>
                    <div className="job-meta">
                      <span>{job.posted}</span>
                      <span>{job.salary}</span>
                    </div>
                  </div>
                  <div className="job-actions">
                    <button
                      type="button"
                      className="job-apply-button"
                    >
                      Apply
                    </button>
                    <button
                      type="button"
                      onClick={() => removeJob(job.id)}
                      className="job-remove-button"
                      aria-label="Remove job"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                        aria-hidden="true"
                      >
                        <path
                          fillRule="evenodd"
                          d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                          clipRule="evenodd"
                        />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
}
